import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';

import { Timeline } from './screens/student/Timeline';
import { VC } from "./screens/video_conference/VC";
import {ChangePassword} from "./screens/changepassword/ChangePassword";
import { ResetPassword } from './screens/resetpassword/ResetPassword';
import {MasterReport} from "./screens/reports/MasterReport";
import {MasterReport2} from "./screens/reports/MasterReport2";
import {MasterReport3} from "./screens/reports/MasterReport3";
import {LeaveReport} from "./screens/reports/LeaveReport";
import {SalaryReport} from "./screens/reports/SalaryReport"; 
import {AttedanceSummaryReport} from "./screens/reports/AttedanceSummaryReport";
import { FOPaymentReport } from './screens/reports/FOPaymentReport';
import { ModuleExport } from './screens/reports/ModuleExport';

export default [
    <Route exact path="/configuration" render={() => <Configuration />} />,
    <Route exact path="/timeline" render={(props) => <Timeline {...props}/>} />,
    <Route exact path="/vc/:id" render={(props) => <VC {...props}/>}  />,
    <Route exact path="/changepassword" render={(props) => <ChangePassword {...props}/>}  />,
    <Route exact path="/reset-password" render={(props) => <ResetPassword {...props} />}  />,
    <Route exact path="/generalquery" render={(props) => <MasterReport  rptTtile="General Query Report" rpt="GQ" {...props} />} />,
    <Route exact path="/hbr" render={(props) => <MasterReport rptTtile="Hospital Bill Report" rpt="HBR" {...props} />} />,
    <Route exact path="/hir" render={(props) => <MasterReport rptTtile="Invoice Report" rpt="HIR" {...props} />} />,
    <Route exact path="/hrc" render={(props) => <MasterReport rptTtile="Hospital Reclaim Report" rpt="HRC" {...props} />} />,
    <Route exact path="/fopaymreport" render={(props) => <FOPaymentReport rptTtile="Fo Payment Report" rpt="FO" {...props} />} />,
    <Route exact path="/repoexport" render={(props) => <ModuleExport rptTtile="Module Export" rpt="ModuleExport" {...props} />} />,
    <Route exact path="/dsrreport" render={(props) => <MasterReport2 rptTtile="DSR Report" rpt="HRC" {...props} />} />,
    <Route exact path="/invreport" render={(props) => <MasterReport3 rptTtile="Invoice Report" rpt="HRC" {...props} />} />,
    <Route exact path="/leavereport" render={(props) => <LeaveReport rptTtile="Leave Report" rpt="HRC" {...props} />} />,
    <Route exact path="/empsalreport" render={(props) => <SalaryReport rptTtile="Salary Report" rpt="HRC" {...props} />} />,
    <Route exact path="/attendreport" render={(props) => <AttedanceSummaryReport rptTtile="Attendance Report" rpt="HRC" {...props} />} />,
    
    
];
